<template>

    <section class="hero flex">
        <div class="hero-body flex_block">
            <div class="container has-text-centered">
                <IconWarning class="icon_warning" />
                <h1 class="error_title title is-size-2">{{ $t('modules.friends.friendTokenError.title') }}</h1>
                <p>{{ $t('modules.friends.friendTokenError.text1') }}</p>
                <p>{{ $t('modules.friends.friendTokenError.text2') }}</p>
            </div>
        </div>
    </section>

</template>

<script>
export default {
    name: 'FriendTokenError',
    components: {},
    data(){
        return {}
    },
    computed: {

    },
    methods: {

    }
}

</script>

<style lang="scss">

.survey_section{
    display: flex;
    .hero{
        .flex_block{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 200px;
        }
    }
}
.icon_warning{
    width: 100px;
    fill: $danger;
}
.error_title{
    color: $danger!important;
}

</style>